import React from "react";
import {
  DollarSign,
  Calendar,
  Layers,
  Hash,
  Target,
  Shield,
  Activity,
  User,
  Percent,
  Home,
} from "lucide-react";
import './reservedcard.css'

const NA = (v) => (v ? v : "N/A");

const ReservedCard = ({ item }) => {
  return (
    <div className="customer-port-folio-reserved-fo-card">

      {/* TOP ROW HIGHLIGHT */}
      <div className="customer-port-folio-reserved-fo-stockname">
        {NA(item.underlyingName)}
      </div>

      <div className="customer-port-folio-reserved-fo-toprow">
        <div><Layers size={18}/> Instrument: {NA(item.instrumentType)}</div>
        <div><DollarSign size={18}/> Invested: ₹{NA(item.amountInvested)}</div>
        <div><Hash size={18}/> Lot Size: {NA(item.lotSize)}</div>
        <div><Target size={18}/> Option Type: {NA(item.optionType)}</div>
        <div><Activity size={18}/> Status: {NA(item.status)}</div>
      </div>

      {/* BOTTOM GRID */}
      <div className="customer-port-folio-reserved-fo-grid">
        <div><Shield size={16}/> Risk %: {NA(item.riskPercentage)}</div>
        <div><Activity size={16}/> ISIN: {NA(item.isin)}</div>
        <div><Target size={16}/> Strike Price: {NA(item.strickPrice)}</div>
        <div><Calendar size={16}/> Expiry Date: {NA(item.expiryDate)}</div>
        <div><Home size={16}/> Contract Size: {NA(item.contractSize)}</div>
        <div><DollarSign size={16}/> Entry Price: ₹{NA(item.entryPrice)}</div>
        <div><Layers size={16}/> Exchange: {NA(item.exchange)}</div>
        <div><Activity size={16}/> Position Type: {NA(item.positionType)}</div>
        <div><Target size={16}/> Product Type: {NA(item.productType)}</div>
        <div><DollarSign size={16}/> Underlying Price: ₹{NA(item.underlyingPrice)}</div>
        <div><User size={16}/> Placed By: {NA(item.placedBy)}</div>
        <div><User size={16}/> Client Code: {NA(item.clientCode)}</div>
        <div><Percent size={16}/> Greeks: {NA(item.greeks)}</div>
        <div><DollarSign size={16}/> Margin Required: ₹{NA(item.marginRequired)}</div>
        <div><Target size={16}/> Target Price: {NA(item.targetPrice)}</div>
        <div><Shield size={16}/> Stoploss: {NA(item.stoploss)}</div>
      </div>

    </div>
  );
};

export default ReservedCard;